import { Image } from 'antd';
import { useTranslation } from 'react-i18next';

import { ColorModel } from '@common/models';
import { COMING_SOON_IMAGE } from '@common/utils';
import ImageUtils from '@core/utils/ImageUtils';

import './price-area-default-info.scss';

interface SelectedColorProps {
    selectedColor?: ColorModel;
}

const PriceAreaDefaultText = ({ selectedColor }: SelectedColorProps) => {
    const { t } = useTranslation();

    return (
        <div className={selectedColor ? 'text-descriptor' : 'default-text-descriptor'}>
            {t('PRICING_AREA.DEFAULT_DESCRIPTION')}
        </div>
    );
};

const SelectedColorDescription = ({ selectedColor }: SelectedColorProps) => {
    return selectedColor ? (
        <div className={'default-image-text-container'}>
            <Image
                className="image"
                preview={false}
                alt={'default'}
                width={240}
                height={156}
                src={ImageUtils.imgUrl(
                    selectedColor.beautyShotImageUrl ? selectedColor.beautyShotImageUrl : COMING_SOON_IMAGE,
                    300
                )}
            />
            <PriceAreaDefaultText />
        </div>
    ) : null;
};

const PriceAreaDefaultInfo = ({ selectedColor }: SelectedColorProps): JSX.Element => {
    return (
        <div className="default-container">
            {selectedColor ? (
                <SelectedColorDescription selectedColor={selectedColor} />
            ) : (
                <PriceAreaDefaultText selectedColor={selectedColor} />
            )}
        </div>
    );
};

export default PriceAreaDefaultInfo;
